document.addEventListener("DOMContentLoaded",()=>{

new Swiper(".featureSwiper",{

loop:true,

centeredSlides:true,

slidesPerView:1.2,

spaceBetween:2,

speed:800,

autoplay:{

delay:4000,

disableOnInteraction:false

},



breakpoints:{

750:{

slidesPerView:1.45

},

990:{

slidesPerView:1.45

}

}

});

});